var table_viewer_default = {
  "viewMode": "hXeF-",
  "editMode": "lnPv5",
  "container": "WuiJ8",
  "cell": "cHpsF"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
